<template>
  <div class="answer_list">
    <div class="answer_center">
      <!--轮播-->
      <div class="home_swiper">
        <!--轮播//插件-->
        <div id="bigOne_swiper" class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in swiperData" :key="item.articleId">
              <img :src="item.url" alt="">
            </div>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" style="color: #fff;"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next" style="color: #fff;"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        </div>
      </div>
      <div v-if="0" class="answer_nav">
        <div class="nav_item">病因类</div>
        <div class="nav_item">症状类</div>
        <div class="nav_item">检查诊断类</div>
        <div class="nav_item">用药类</div>
        <div class="nav_item">急救类</div>
        <div class="nav_item">治疗类</div>
        <div class="nav_item">家庭护理类</div>
        <div class="nav_item">其他问题</div>
      </div>
      <div class="center_box">
        <!--左-->
        <div class="answer_left">
          <div class="card_leftList_centre">
            <div class="item_List" v-for="item in AnswerData" :key="item.id" @click="handleToShow(item.id)">
              <div class="list_twoBox">
                <div class="list_twoBox_Q">
                  <div>Q</div>
                  <span>{{item.title}}</span>
                </div>
                <div class="list_twoBox_A">
                  <div>A</div>
                  <span>{{item.content}}</span>
                </div>
                <div class="list_twoBox_bottom">
                  <div class="doctor_head">
                    <img :src="item.coverUrl" alt="">
                    <div class="doctor_name">{{item.doctorName}}</div>
                    <div class="doctor_hospital">{{item.hospitalName}}</div>
                    <div class="doctor_twoTitle">{{item.departmentName}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--右-->
        <div class="answer_right">
          <div class="title_box" style="margin-bottom: 30px">热门咨询</div>
          <div class="card_right_list">
            <div class="right_list_item" v-for="(item,index) in hotAnswerData" :key="item.id"  @click="handleToShow(item.id)">
              <div class="item_num">{{index+1}}</div>
              <div class="item_title">{{item.title}}</div>
              <div class="item_oneCard">
                <div class="oneCard_left">
                  <img :src="item.coverUrl" alt="">
                  <div>{{index+1}}</div>
                </div>
                <div class="oneCard_right">
                  <div class="header">{{item.title}}</div>
                  <div class="title">
                    <div>{{item.doctorName}}</div>
                    <span>{{item.doctorLevelName}}</span>
                  </div>
                  <!--<div class="time">2020-03-12</div>-->
                </div>
              </div>
            </div>
          </div>
          <div class="title_box" style="margin: 30px 0">医生推荐</div>
          <div class="recommend_box">
            <div class="swiper_listBox" v-for="item in HotdoctorData" :key="item.doctorId" @click="handleDoctorShow(item.doctorId)">
              <!--上-->
              <div class="slide_top">
                <img :src="item.headImage" alt="">
              </div>
              <!--中-->
              <div class="slide_center">
                <div class="user_name">
                  <div>{{item.doctorName}}</div>
                  <span>{{item.doctorLevelName}}</span>
                </div>
                <div class="user_title">
                  <div>{{item.hospitalName}}</div>
                  <span>{{item.departmentName}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--分页-->
    <div class="Pagination">
      <Pagination  :pageSize="total" v-model="dataForm.page" @on-jump="jump" />
    </div>
  </div>
</template>

<script>
  import Pagination from '../../components/pagination/index'
  import Swiper from 'swiper'
  export default {
    components:{
      Pagination
    },
    data(){
      return {
        total:10,  // 总分页数
        dataForm:{
          page:1,
          size:6,
        },
        swiperData:[],
        AnswerData:[],
        hotAnswerData:[],
        HotdoctorData:[],
      }
    },
    methods:{
      // 点击医生
      handleDoctorShow(id) {
        this.$router.push({path:'/salientDoctor/salientDoctorShow/'+id,query:{}})
      },
      jump(page){
        this.dataForm.page = page
        this.getAnswerList()
      },
      handleToShow(id) {
        this.$router.push({path:'/answerList/answeShow/'+id,query:{}})
      },
      // 初始化头部轮播
      _initSwiper() {
        let mySwiper = new Swiper('#bigOne_swiper', {
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          loop : true,
          pagination: {
            el: '.swiper-pagination',
            clickable :true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          //用户操作后, autoplay会默认停止, 这个是取消禁止autoplay
          autoplayDisableOnInteraction: false,
        })
      },
      // 获取轮播数据
      getSwiperDara() {
        let params = {
          type:1
        }
        this.$api.mykp_home.findSwiperTree(params) .then(res => {
          if(res.code == '000000') {
            this.swiperData = res.infos
            this.$nextTick(() => {
              this._initSwiper()
            })
          }
        })
      },
      // 获取问答列表
      getAnswerList() {
        const data = {
          type:1,
          page:this.dataForm.page,
          size:this.dataForm.size,
          hot:false
        }
        this.$api.mykp_home.findVideoTree(data) .then(res => {
          if(res.code == '000000'){
            this.AnswerData = res.infos.list
            this.total = Math.ceil(res.infos.total/6)
          }
        })
      },
      // 获取热门列表
      getHotAnswerList() {
        const data = {
          type:1,
          page:1,
          size:10,
          hot:true
        }
        this.$api.mykp_home.findVideoTree(data) .then(res => {
          if(res.code == '000000'){
            this.hotAnswerData = res.infos.list
          }
        })
      },
      // 获取热门医生列表
      getHotDoctorList() {
        let params = {
          page:1,
          size:3,
        }
        this.$api.mykp_home.findDoctorTree(params) .then(res => {
          if(res.code == '000000') {
            this.HotdoctorData = res.infos.list
          }
        })
      },
    },
    activated() {
      this.getSwiperDara()
      this.getAnswerList()
      this.getHotAnswerList()
      this.getHotDoctorList()
    }
  }
</script>
<style lang="stylus" scoped>
  .answer_list{
    margin-top 30px
    .answer_center{
      width: 1200px
      margin 0 auto
      .answer_nav{
        display flex
        .nav_item{
          height: 40px
          padding 0 40px
          line-height: 40px
          background #f2f2f2
          font-size: 16px;
          color: #333
          cursor: pointer
          &:hover{
            background #199ed8
            color: #fff
          }
          &.active{
            background #199ed8
            color: #fff
          }
        }
      }
      .center_box{
        margin-top 30px
        display flex
        justify-content space-between
        .answer_left{
          width: 821px
          .card_leftList_centre{
            .item_List{
              cursor: pointer
              margin-bottom 25px
              &:after{
                content ''
                display block
                width: 100%
                height: 1px
                border-top 1px dashed #eee
                margin-top 15px
              }
              .list_twoBox{
                .list_twoBox_Q{
                  display flex
                  align-items center
                  flex-wrap wrap
                  &:after{
                    content ''
                    display block
                    width: 465px
                    height: 1px
                    border-top 1px dashed #eee
                    margin-top 25px
                    margin-right 300px
                  }
                  >div{
                    width: 40px
                    height: 40px
                    border-radius: 5px;
                    background #63a3fc
                    font-weight: 700;
                    font-style: normal;
                    font-size: 20px;
                    color: #fff
                    text-align: center
                    line-height:40px
                    margin-right 20px
                  }
                  >span {
                    font-weight: 700;
                    font-style: normal;
                    font-size: 16px;
                    color: #333
                    cursor: pointer
                  }
                }
                .list_twoBox_A{
                  margin-top 20px
                  display flex
                  /*align-items center*/
                  >div{
                    width: 40px
                    height: 40px
                    border-radius: 5px;
                    background #f57a7c
                    font-weight: 700;
                    font-style: normal;
                    font-size: 20px;
                    color: #fff
                    text-align: center
                    line-height:40px
                    margin-right 20px
                  }
                  >span {
                    width 95%
                    font-style: normal;
                    color: #333
                    font-size: 14px;
                    line-height: 22px;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 4;
                    -webkit-box-orient: vertical;
                  }
                }
                .list_twoBox_bottom{
                  display flex
                  align-items center
                  .doctor_head{
                    display flex
                    align-items center
                    margin-top 20px
                    >img{
                      width: 60px;
                      height: 60px;
                      border-radius 50%
                      margin-right 15px
                    }
                    .doctor_name{
                      font-weight: 700;
                      font-style: normal;
                      font-size: 14px;
                      color: #5E5E5E;
                      margin-right 15px
                      max-width: 90px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                    .doctor_hospital{
                      font-size: 14px;
                      color: #5E5E5E;
                      margin-right 15px
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      max-width 150px
                    }
                    .doctor_twoTitle{
                      font-size: 14px;
                      color: #5E5E5E;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      max-width 150px
                    }
                  }
                }
              }
            }
          }
        }
        .answer_right{
          width: 361px
          .card_right_list{
            .right_list_item{
              margin-top 14px
              display flex
              align-items center
              cursor: pointer
              &:nth-child(-n +3){
                display block
                padding-bottom  10px
                .item_num{
                  display none
                }
                .item_title{
                  display none
                }
                .item_oneCard{
                  display flex
                }
                &:after {
                  content ''
                  display flex
                  width: 361px
                  height: 1px
                  border-top 1px dashed #eee
                  margin-top 20px
                  transform translateY(3px)
                }
              }
              .item_num{
                width: 35px;
                height: 29px;
                text-align: center
                line-height 29px
                font-size: 18px;
                color: #A1A1A1;
                border 1px solid #e4e4e4
                margin-right 15px
              }
              .item_title{
                font-size: 16px;
                color: #333
                width 80%
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .item_oneCard{
                display none
                .oneCard_left{
                  position relative
                  >img{
                    width: 148px;
                    height: 93px;
                  }
                  >div{
                    position absolute
                    bottom:3px
                    left: 0
                    width: 35px;
                    height: 29px;
                    text-align: center
                    line-height 29px
                    font-size: 18px;
                    color: #fff;
                    background #ff8a8a
                    margin-right 15px
                  }
                }
                .oneCard_right{
                  margin-left 20px
                  width: 185px
                  .header{
                    max-width 200px
                    font-weight: 700;
                    font-size: 18px;
                    color: #333
                    line-height: 24px
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                  }
                  .title{
                    margin-top 15px
                    max-width 200px
                    display flex
                    >div{
                      font-size: 16px;
                      color: #A1A1A1;
                      max-width: 40%
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      margin-right  10px
                    }
                    >span{
                      font-size: 16px;
                      color: #A1A1A1;
                      max-width: 60%
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }
                  }
                  .time{
                    margin-top 15px
                    font-size: 14px;
                    color: #C9C9C9;
                    text-align: right
                  }
                }
              }
            }
          }
          .title_box{
            font-weight: 700;
            font-style: normal;
            font-size: 18px;
            width: 170px;
            height: 40px;
            background #1083f8
            text-align: center
            line-height:40px
            border-radius: 5px;
            color: #fff
          }
          .recommend_box{
            .swiper_listBox{
              width: 218px;
              display flex
              flex-direction column
              align-items center
              margin 30px auto
              .slide_top{
                width: 150px;
                height: 150px;
                background #f2f2f2
                border-radius 50%
                display flex
                align-items center
                justify-content center
                >img{
                  width: 150px;
                  height: 150px;
                  border-radius 50%
                }
              }
              .slide_center{
                display flex
                flex-direction column
                align-items center
                .user_name{
                  margin-top 10px
                  display flex
                  align-items center
                  >div{
                    font-weight: 700;
                    font-size: 18px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    width 65px
                    margin-right 10px
                  }
                  >span{
                    font-size: 16px;
                    color #fff
                    width: 85px;
                    height: 31px;
                    background #1083f8
                    display block
                    text-align: center
                    line-height 31px
                    border-radius: 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .user_title{
                  margin-top 20px
                  display flex
                  align-items center
                  >div{
                    width: 100px
                    font-size: 14px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  >span{
                    width: 100px
                    display block
                    font-size: 14px;
                    color: #000000;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
          }
        }
      }

    }
    .Pagination{
      margin-top 20px
    }
  }
  // 轮播区
  .home_swiper{
    width 1200px
    margin 0 auto
    // 轮播
    .swiper-container {
      margin-top 20px
      width:100%
      height 600px
      .swiper-slide{
        cursor: pointer
      }
      img{
        width 100%
        height 100%
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/answer/List.vue